import { Localized, useLocalization } from "@fluent/react";
import { useParams, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import { useCallback, useEffect, useState } from "react";
import { loadWorkflowDefinition } from "./api/workflowApi";
import { WorkflowDefinition } from "./api/workflowTypes";
import { APIError } from "../../../app/appTypes";
import { unwrapResult } from "@reduxjs/toolkit";
import { LoadingContainer } from "../../../app/LoadingContainer";
import { ServerErrorMsg } from "../../../app/ServerErrorMsg";
import { Container, Grid, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import WorkflowDefinitionHeader from "./controls/WorkflowDefinitionHeader";
import { WorkflowDefinitionEditor } from "./WorkflowDefinitionEditor";

type FormTabs = "content" | "details" | "attachments"


export const WorkflowDefinitionForm = () => {
    const { id: paramId } = useParams(); const id = paramId ?? ''

    return <>
        <EditForm id={id} />
    </>
}
const EditForm = (props: { id: string }) => {
    const { id } = props
    const { l10n } = useLocalization()
    const dispatch = useAppDispatch()
    const [workflowDefinition, setWorkflowDefinition] = useState<WorkflowDefinition>()
    const [error, setError] = useState<APIError | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)


    //loading data
    useEffect(() => {
        setIsLoading(true);

        dispatch(loadWorkflowDefinition(id))
            .then(unwrapResult)
            .then(setWorkflowDefinition)
            .catch((err) => setError(err))
            .finally(() => setIsLoading(false));
    }, [])


    // Tab handling
    const [params, setParams] = useSearchParams()
    const tab = params.get('tab') as FormTabs || 'main'
    const setTab = (tab: FormTabs) => {
        params.set('tab', tab)
        setParams(params, { replace: true })
    }

    const handleTabChange = useCallback((_, newTab) => {
        setTab(newTab)
    }, [])

    if (isLoading) {
        return <>
            <LoadingContainer />
        </>
    }

    if (error || !workflowDefinition) {
        return <ServerErrorMsg err={error} />
    }

    return <>
        <Container maxWidth={false} sx={{ padding: "2px", paddingLeft: "2px!important", paddingRight: "2px!important" }}>
            <Grid container >
                <Grid item xs={12}>
                    <WorkflowDefinitionHeader workflowDefinition={workflowDefinition} />
                </Grid>
                <Grid item xs={12}>

                    <TabContext value={tab}>
                        <TabList onChange={handleTabChange}>
                            <Tab
                                key={0}
                                value="main"
                                label={<Localized id="">Definicja</Localized>} />
                        </TabList>
                        <TabPanel value="main" sx={{ padding: "2px", paddingLeft: "2px!important", paddingRight: "2px!important" }}>
                            <WorkflowDefinitionEditor definitionId={id} />
                        </TabPanel>
                    </TabContext>
                </Grid>
            </Grid>
        </Container>
    </>
}